import { ErrorCode } from '@mogul/api-client';
import { parseApiErrors } from '@mogul/shared';
import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';

import { authApi, authApiFactory } from '../../api';
import { OkModal } from '../../components/common/modal/OkModal.component';
import { ResetPasswordComponent } from '../../components/reset-password/ResetPassword.component';
import { ResetPasswordInitComponent } from '../../components/reset-password/ResetPasswordInit.component';
import { ModalStateContext } from '../../contexts/app-state-context/modal-state.context';

export const ResetPasswordPage: React.FC = () => {
  const { setModal } = useContext(ModalStateContext);
  const history = useHistory();

  const location = useLocation();

  const token = new URLSearchParams(location.search).get('token');

  if (token != null) {
    return (
      <ResetPasswordComponent
        onPasswordResetPress={(password: string, verifyPassword: string) => {
          if (password !== verifyPassword) {
            setModal(OkModal('Passwords do not match.'));
            return;
          }

          return authApiFactory({ apiKey: token })
            .setPassword({ setPasswordData: { password } })
            .then(
              () => {
                setModal(
                  OkModal('Your password has been reset.', () => {
                    history.push('/login');
                  }),
                );
              },
              error => {
                for (const { code } of parseApiErrors(error)) {
                  if (
                    code === ErrorCode.AuthUnauthorized ||
                    code === ErrorCode.AuthExpired
                  ) {
                    setModal(
                      OkModal('Invalid password reset link.', () => {
                        history.push('/login');
                      }),
                    );
                    return;
                  }
                }

                setModal(
                  OkModal('An error occured, please try again later.', () => {
                    history.push('/login');
                  }),
                );
              },
            );
        }}
      />
    );
  }

  return (
    <ResetPasswordInitComponent
      onPasswordResetInitPress={email =>
        authApi
          .createPasswordChange({ passwordChangeData: { login: email } })
          .then(
            () => {
              setModal(
                OkModal(
                  'An email has been sent to that account, if it exists.',
                ),
              );
            },
            error => {
              setModal(OkModal('An error occured, please try again later.'));
              throw error;
            },
          )
      }
    />
  );
};
